<template>
    <carousel class='carouselTiles' :perPageCustom='[[768,3],[1024,4]]' navigationEnabled='true' paginationColor='#888888' pagination>
        <slide  v-for='(image, index) in gallery' :key='image.id' >
            <div class='resourceTile'>
                <div :class='color' v-if='image.image.type == "Image"' @click='selectImage(index)'>
                    <img :src='image.thumbnail.url' >
                    <div class='resourceText'><h2>{{image.title}}</h2></div>
                </div>    
                <div v-else class='cs-cerulean' @click='selectImage(index)'>
                    <img v-if='image.thumbnail == null' class='resourceImage' :src='require("../assets/pdf_thumbnail.png").default'>
                    <img v-else class='resourceImage' :src='image.thumbnail.url'>
                    <div class='resourceText'><h2>{{image.title}}</h2></div>
                </div>
            </div>
        </slide>
    </carousel>
</template>

<style lang="less">
.carouselTiles {
    .resourceTile {

    }
}

</style>

<script>
import { Carousel, Slide } from 'vue-carousel';


export default {
    name: 'scrolling-gallery-thumbnails',
    props: ['gallery', 'color'],
    data() {
        return {
            galleryCopy: this.gallery
        }
    },
    methods: {
        next() {
            this.galleryCopy.unshift(this.galleryCopy.pop());
        },
        selectImage(index) {
            this.$emit('selectImage', index);
        }
    },
    components: {
        Carousel,
        Slide
    }
}
</script>